module.exports = __webpack_public_path__ + "img/icon-check.3f34598f.svg";